export default "__VITE_ASSET__bWGrV3Rm__"